<div class="background">
  <div class="row d-flex align-items-lg-center align-content-center justify-content-center">
    <div class="col-lg-6 col-12 text-center d-lg-none mb-8">
      <img src="/assets/images/not-found/404.webp" class="col-10 col-lg-8 mx-auto">
    </div>
    <div class="col-lg-6 col-12 text-center">
      <h1 class="mx-auto text text-center">{{ 'YouFellIntoABlackHole' | translate}}</h1>
      <button class="btn mt-4 mx-auto px-4 fw-bold fs-4 btn"
              onclick="window.location.href='/dashboard'">
        {{ 'BackHome' | translate}}</button>
    </div>
    <div class="col-lg-6 col-12 text-center d-none d-lg-flex">
      <img src="/assets/images/not-found/404.webp" class="col-8 mx-auto">
    </div>
  </div>
</div>
